import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["alert"]

  connect() {
    // Auto-hide after 5 seconds
    setTimeout(() => {
      this.hide()
    }, 5000)
  }

  hide() {
    this.alertTarget.classList.add('opacity-0', 'transform', 'translate-y-[-10px]', 'transition-all', 'duration-300')
    
    // Remove the element after the animation
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
} 